module.exports = __webpack_public_path__ + "static/img/bcg_v.45282d76.png";